import './libraries/stylesheets'
import './libraries/scripts'

import Vue from 'vue'
import axios from './axios'
import App from './App.vue'
import getRouter from './router'
import store from './store/index'
import Meta from 'vue-meta'
import { i18n } from './locale'
import loading from 'vuejs-loading-screen'
import VueToastr from '@deveodk/vue-toastr'
import VueSweetalert2 from 'vue-sweetalert2'
import helpers from './plugins/helpers'
import Multiselect from 'vue-multiselect'
import Permissions, { copyPermission } from './permissions'
import Modal from './components/Modal'
import XChart from '@laramab/x-chart'

Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$base_api = process.env.VUE_APP_API
Vue.prototype.$token = process.env.VUE_APP_TOKEN
Vue.prototype.$nbPerPage = 10
Vue.use(Meta)
Vue.use(loading, { bg: '#656565ab' })
Vue.use(helpers)
Vue.use(XChart)
Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 2000
})
Vue.use(VueSweetalert2, {
  confirmButtonColor: '#41b882',
  cancelButtonColor: '#ff7674'
})

const moment = require('moment')
require('moment/locale/es')
Vue.use(require('vue-moment'), { moment })

Vue.component('multiselect', Multiselect)
Vue.component('modal', Modal)

Vue.prototype.$Permissions = Permissions
Object.defineProperty(window, 'permission', {
  get: copyPermission
})

const vm = new Vue({
  router: getRouter(store),
  store,
  i18n,
  render: (h) => {
    return h(App)
  }
}).$mount('#app')

export default vm
